import { render, staticRenderFns } from "./user-id.vue?vue&type=template&id=79861055&"
import script from "./user-id.vue?vue&type=script&lang=js&"
export * from "./user-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports